import { ArrowUpRight, Brand } from '../components/common/Brand'

export function PricingPage() {
  return (
    <main className="pricing-page">
      <div className="grain" />
      <nav className="nav">
        <Brand />
        <a className="pricing-back" href="/">
          ← Back home
        </a>
      </nav>
      <section className="pricing-content" aria-labelledby="pricing-title">
        <p className="tag">
          <span className="spark">✦</span> Pricing
        </p>
        <div className="coming-soon-banner" role="status">
          <span>✦</span>
          Pricing is coming soon — join the waitlist for first access.
        </div>
        <h1 id="pricing-title">
          Pricing details
          <br />
          <em>coming soon.</em>
        </h1>
        <p className="pricing-intro">
          We’re working on flexible options for every stage of your competitive
          programming journey. Details will be here before classes launch.
        </p>
        <a className="pricing-cta" href="/#signup">
          Join the waitlist <ArrowUpRight />
        </a>
      </section>
    </main>
  )
}
